import {
  useEffect,
  useState,
} from 'react';
import { replace } from 'connected-react-router';
import trimStart from 'lodash.trimstart';
import qs from 'querystring';
import { useDispatch } from 'react-redux';
import {
  generatePath,
  useLocation,
} from 'react-router';
import { SignupSearchParams } from '../../../../@types/routes-params.d';
import { StorageEntries } from '../../../../@types/storage-entries';
import { SignupFlow } from '../../../../@types/signup.d';
import { storeInLocalStorage } from '../../../../actions/storage';
import Routes from '../../../../routes';
import usePersonna from '../../../../utils/hooks/usePersonna';

export default function useSignUpIntent():void {
  const dispatch = useDispatch();
  const { type } = usePersonna();
  const [urlParams, setUrlParams] = useState<SignupSearchParams>();

  // handle url params
  const { search } = useLocation();
  useEffect(() => {
    const urlSearchParams: SignupSearchParams = qs.parse(trimStart(search, '?'));
    if (urlSearchParams) {
      setUrlParams({
        ...urlParams,
        ...urlSearchParams,
      });
    }
  }, [search]);

  useEffect(() => {
    // handle store invitation_code
    if (urlParams?.invitation_code) {
      dispatch(storeInLocalStorage({
        key: StorageEntries.mentorInvitationCode,
        value: urlParams.invitation_code,
      }));
    }

    if (
      type === 'visitor'
      && urlParams?.signup === SignupFlow.students
    ) {
      dispatch(replace({
        pathname: generatePath(Routes.signupView, { flow: SignupFlow.students }),
      }));
    }
  }, [
    urlParams?.signup,
    urlParams?.invitation_code,
  ]);
}
